import { TOTADMIN_PERMISSIONS } from 'constants/roles';
import { UserPermission } from 'data/__generated__';

export const isTotadminUser = (user: { permissions: { userGroup: UserPermission }[] }) => {
    return user.permissions.some((p) => TOTADMIN_PERMISSIONS.includes(p.userGroup));
};
